import React from 'react'
import { TextField } from "@mui/material";
import { useTheme } from '@mui/material/styles';


const FullTextField = (props) => {
    const theme = useTheme();
    const textFieldStyle={
        background:theme.palette.componentBackgrounds.new,
        width:'100%',
        my:1.75,
        border:'none',
        height:40,
        borderRadius:1
    }
    return (
        <TextField id={props.id} size='small'
        label={props.title} helperText={props.helperText} onChange={props.onChange} onBlur={props.onBlur} value={props.value} name={props.name} type={props.type} {...props.register} error={props.error} placeholder={props.label} disabled={props.disabled} sx={textFieldStyle} />
    )
}

export default FullTextField